import { render, staticRenderFns } from "./login-form.vue?vue&type=template&id=19d04af2&"
import script from "./login-form.component.ts?vue&type=script&lang=ts&"
export * from "./login-form.component.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/backOffice/backOffice/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('19d04af2')) {
      api.createRecord('19d04af2', component.options)
    } else {
      api.reload('19d04af2', component.options)
    }
    module.hot.accept("./login-form.vue?vue&type=template&id=19d04af2&", function () {
      api.rerender('19d04af2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/app/core/login-form/login-form.vue"
export default component.exports